import React from 'react';
import TableReadPlayer from './TableReadPlayer';

/** Standalone table-read page. Rendered in the header-free layout; the player fills the viewport. */
export default function Player({ base, initialScene, backUrl, scriptTitle, isDemo }) {
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TableReadPlayer base={base} initialScene={initialScene} backUrl={backUrl}
                       scriptTitle={scriptTitle} isDemo={isDemo} />
    </div>
  );
}
